import { useState } from 'react';
import { EnvelopeIcon } from '@heroicons/react/24/outline';
import type { Movimentacao, Solicitacao } from '../../../../models';
import { MOMENTO_EMAIL_CLIENTE_LABELS, modelosAplicaveis } from '../../../../models/emailCliente.modelos';
import type { ModeloEmailCliente } from '../../../../models/emailCliente.modelos';
import { useModelosEmailClienteQuery } from '../../../../hooks/data';
import PrepararEmailClienteModal from './PrepararEmailClienteModal';

interface EmailsClienteSectionProps {
  solicitacao: Solicitacao;
  movimentacoes: Movimentacao[];
}

/** E-mails para o Cliente que valem pra esta Solicitação (tipo + Clientes da Solicitação e das
 * Movimentações) — só o SI vê. Some quando nenhum modelo se aplica. */
export default function EmailsClienteSection({ solicitacao, movimentacoes }: EmailsClienteSectionProps) {
  const { data: modelos = [] } = useModelosEmailClienteQuery();
  const [aberto, setAberto] = useState<ModeloEmailCliente | null>(null);
  const clienteIds = [solicitacao.clienteId, ...movimentacoes.map((m) => m.clienteId)];
  const aplicaveis = modelosAplicaveis(modelos, solicitacao.tipoSolicitacao, clienteIds);

  if (aplicaveis.length === 0) return null;

  return (
    <section className="rounded-lg border border-gray-200 bg-white p-4">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <h2 className="font-montserrat text-base font-semibold text-gray-900">E-mails para o cliente</h2>
          <p className="text-sm text-gray-500">Pedido de acesso/máquina ou aviso de saída, pronto pra abrir no Outlook.</p>
        </div>
        <div className="flex flex-wrap gap-2">
          {aplicaveis.map((modelo) => (
            <button key={modelo.id} type="button" className="btn-secondary inline-flex items-center gap-1.5 text-sm" onClick={() => setAberto(modelo)}>
              <EnvelopeIcon className="h-4 w-4" aria-hidden="true" />
              {MOMENTO_EMAIL_CLIENTE_LABELS[modelo.momento]} · {modelo.clienteNome}
            </button>
          ))}
        </div>
      </div>
      {aberto && (
        <PrepararEmailClienteModal
          modelo={aberto}
          solicitacao={solicitacao}
          movimentacoes={movimentacoes}
          onClose={() => setAberto(null)}
        />
      )}
    </section>
  );
}
